
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block;
}

:host([height-grow]) {

    display: flex;

    height: 100%;
}

:host([height-grow]) .ghs-step {

    flex-grow: 1;
}

.ghs-step {

    position: relative;

    margin: 2rem;

    border-radius: 0.75rem;

    border-width: 2px;

    border-style: solid;

    border-color: var(--primary-blue);

    background-color: var(--neutral-white);

    padding-left: 3rem;

    padding-top: 1.5rem;

    padding-right: 1.5rem;

    padding-bottom: 1rem;
}

.step-heading {

    margin-top: 0px;

    margin-bottom: 1rem;

    font-family: var(--ff-display);

    font-size: var(--fs-2xl);

    line-height: var(--lh-2xl);
}

.step-content {

    font-family: var(--ff-body);
}

.step-number {

    position: absolute;

    left: -2rem;

    top: -4rem;

    display: flex;

    height: 4rem;

    width: 4rem;

    align-items: center;

    justify-content: center;

    border-radius: 9999px;

    font-family: var(--ff-display);

    font-size: var(--fs-3xl);

    line-height: var(--lh-3xl);
}

:host([site='GHS']) .step-heading {

    font-weight: var(--fw-bold);
}

:host([site='GHS']) .step-heading {

    line-height: 1;
}

:host([site='GHS']) .step-heading {

    color: var(--primary-blue);
}

:host([site='GHS']) .step-content {

    font-size: var(--fs-lg);

    line-height: var(--lh-lg);
}

:host([site='GHS']) .step-content {

    color: var(--neutral-gray-1);
}

:host([site='GHS']) .step-number {

    background-color: var(--primary-green);
}

:host([site='GHS']) .step-number {

    color: var(--neutral-white);
}

:host([site='BH']) .ghs-step {

    border-radius: 0.375rem;
}

:host([site='BH']) .ghs-step {

    border-width: 1px;
}

:host([site='BH']) .ghs-step {

    border-color: var(--bh-neutral-default);
}

:host([site='BH']) .ghs-step {

    padding-left: 1.25rem;

    padding-right: 1.25rem;
}

:host([site='BH']) .ghs-step {

    padding-top: 3rem;
}

:host([site='BH']) .ghs-step {

    padding-bottom: 1.75rem;
}

:host([site='BH']) .ghs-step {

    color: var(--bh-neutral-darker);
}

@media (min-width: 1024px) {

    :host([site='BH']) .ghs-step {

        padding-top: 3.5rem;
    }
}

@media (min-width: 1024px) {

    :host([site='BH']) .ghs-step {

        padding-bottom: 3rem;
    }
}

:host([site='BH']) .step-heading {

    margin-bottom: 0.75rem;
}

:host([site='BH']) .step-heading {

    font-family: var(--bh-ff-display);
}

:host([site='BH']) .step-heading {

    font-size: var(--fs-2xl);

    line-height: var(--lh-2xl);
}

@media (min-width: 1024px) {

    :host([site='BH']) .step-heading {

        margin-bottom: 1rem;
    }
}

@media (min-width: 1024px) {

    :host([site='BH']) .step-heading {

        font-size: var(--fs-3xl);

        line-height: var(--lh-3xl);
    }
}

:host([site='BH']) .step-content {

    font-family: var(--bh-ff-body);
}

@media (min-width: 1024px) {

    :host([site='BH']) .step-content {

        font-size: var(--fs-lg);

        line-height: var(--lh-lg);
    }
}

:host([site='BH']) .step-number {

    left: 1.25rem;
}

:host([site='BH']) .step-number {

    background-color: var(--bh-brand-primary-dark);
}

:host([site='BH']) .step-number {

    font-family: var(--bh-ff-body);
}

:host([site='BH']) .step-number {

    font-size: var(--fs-3xl);

    line-height: var(--lh-3xl);
}

:host([site='BH']) .step-number {

    font-weight: var(--fw-bold);
}

:host([site='BH']) .step-number {

    color: var(--bh-neutral-white);
}

@media (min-width: 1024px) {

    :host([site='BH']) .step-number {

        top: -5rem;
    }
}

@media (min-width: 1024px) {

    :host([site='BH']) .step-number {

        height: 5rem;
    }
}

@media (min-width: 1024px) {

    :host([site='BH']) .step-number {

        width: 5rem;
    }
}

@media (min-width: 1024px) {

    :host([site='BH']) .step-number {

        font-size: var(--fs-4xl);

        line-height: var(--lh-4xl);
    }
}
`;